import styled from 'styled-components';

export const PopoverRoot = styled.div`
  position: fixed;
  z-index: 1000;
  inset: 0;
  width: 100%;
`;

export const PopoverWrapper = styled.div`
  display: inline-flex;
  background: ${({ theme }) => theme[theme.color].Popover.background};
  box-shadow: ${({ theme }) => theme[theme.color].Popover.shadow};
  border: ${({ theme }) => theme[theme.color].Popover.border};
  border-radius: 10px;
  width: 100%;
`;
